import { createApp } from "vue";
import { createPinia } from "pinia";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "./styles/tokens.css";
import "./styles/theme.css";
import App from "./App.vue";
import router from "./router";
import { applyStoredTheme, applyStoredTenantColor } from "./styles/theme-runtime";
import tableFreeze from "./utils/tableFreeze";

applyStoredTheme();
applyStoredTenantColor();

createApp(App).use(createPinia()).use(router).use(ElementPlus).use(tableFreeze).mount("#app");   // 表头右键冻结列(2026-10-19)
